import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { from, map, of, switchMap } from 'rxjs';
import { getFullPathFromUrlSegments } from '../../lib/get-full-path';
import { AffiliateService } from '../../services/affiliate.service';
import { GrowthBookService } from '../../services/growth-book.service';
import { LanguageService } from '../../services/language.service';

export const isAffiliateGuard: CanMatchFn = (e, state) => {
  const growthBookService = inject(GrowthBookService);
  const languageService = inject(LanguageService);
  const affiliateService = inject(AffiliateService);

  return growthBookService.load().pipe(
    switchMap(() => {
      const path = (
        getFullPathFromUrlSegments(state, true, languageService.currentLanguage()).join('/') || 'home'
      ).split('/');
      const first = path[0];
      if (path.length === 1 && first && !first.includes('.')) {
        return from(affiliateService.getAffiliate(first)).pipe(map(affiliate => !!affiliate));
      }
      return of(false);
    })
  );
};
